/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-06 18:29:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-07 14:56:23
 */
import http from "@/api";

export const register = params => {
	return http.post("/admin/user/register", params);
};

export const getRegisterCode = params => {
	return http.get("/admin/user/ecode", params);
};

export const validateResetPasswordEmail = params => {
	return http.get("/admin/user/reset/password/code", params);
};

export const getFindPassword = params => {
	return http.post("/admin/user/reset/password", params);
};
